import React from "react";

const SvgClose = () => (
  <svg
    width="29"
    height="30"
    viewBox="0 0 29 30"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      opacity="0.5"
      d="M14.4998 27.0837C21.1733 27.0837 26.5832 21.6738 26.5832 15.0003C26.5832 8.32688 21.1733 2.91699 14.4998 2.91699C7.8264 2.91699 2.4165 8.32688 2.4165 15.0003C2.4165 21.6738 7.8264 27.0837 14.4998 27.0837Z"
      stroke="black"
      strokeWidth="1.75"
    />
    <path
      d="M17.5207 11.9795L11.479 18.0212M11.479 11.9795L17.5207 18.0212"
      stroke="black"
      strokeWidth="1.75"
      strokeLinecap="round"
    />
  </svg>
);

export default SvgClose;
